import PropTypes from "prop-types";
import React from "react";
import cx from "classnames";
import { Row, Col } from "react-bootstrap";
import Measure from "react-measure";

import Button from "src/components/button";
import CustomFieldItem from "./components/CustomFields/CustomFieldItem";
import DetailsView from "./details/DetailsView";
import { localizedStrings } from "../../../../localization";
import DeleteCustomFieldContainer from "./components/delete/DeleteCustomFieldContainer";

import styles from "./Styles.module.scss";

import DraggableFieldsView from "./components/CustomFields/DraggableFieldsView";
import isEqual from "is-equal";
import Slider from "src/components/slider";
import _ from "lodash";
import { DndContext, MouseSensor, useSensor, useSensors } from "@dnd-kit/core";
import {
  arrayMove,
  rectSortingStrategy,
  SortableContext,
  // useSortable,
} from "@dnd-kit/sortable";

class CustomFieldView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 300,
      selection: null,
      deleteField: null,
      creating: false,
      deleting: false,
      errors: {},
      customFields: [],
      selected: "",
    };

    this._handleFieldSelection = this._handleFieldSelection.bind(this);
    this._handleAddFieldClick = this._handleAddFieldClick.bind(this);
    this._handleFieldChange = this._handleFieldChange.bind(this);
    this._handleSaveClick = this._handleSaveClick.bind(this);
    this._handleResetClick = this._handleResetClick.bind(this);
    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._onDeleteSuccess = this._onDeleteSuccess.bind(this);
    this.arrangeOptions = this.arrangeOptions.bind(this);
    this._handleReOrderField = this._handleReOrderField.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedCustomFields = this.localizedSettings.account.custom_fields;
  }

  getChildContext() {
    return {
      selection: this.state.selection,
    };
  }

  componentDidMount() {
    this.props.fetchCustomFields();
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.state.customFields, nextProps.customFields)) {
      this.setState({
        customFields: nextProps.customFields,
      });
    }
  }

  _handleFieldSelection(item) {
    this.setState({
      selection: item,
      creating: false,
      errors: {},
      selected: item,
    });
  }

  _handleAddFieldClick() {
    this.setState({
      selection: {
        name: this.localizedCustomFields.untitled,
        helpText: "",
        options: [],
        searchable: true,
      },
      creating: true,
      selected: "",
    });
    this.props.trackAdoptionMetricsForCustomFieldClickedEvent();
  }

  _handleFieldChange(field, value) {
    this.setState({
      selection: {
        ...this.state.selection,
        [field]: value,
      },
      errors: {},
    });
  }

  _validateForm() {
    var errors = {};

    // const { name, options } = this.state.selection;
    const name = _.get(this.state.selection, "name", "");
    const options = _.get(this.state.selection, "options", []);

    if (!name || name?.trim == "") {
      errors.name =
        this.localizedCustomFields.create_custom_field.error_messages.valid_name;
    }

    if (!options || options?.length == 0) {
      errors.options =
        this.localizedCustomFields.create_custom_field.error_messages.valid_options;
    }

    return errors;
  }

  _handleSaveClick() {
    const errors = this._validateForm();
    if (Object.keys(errors).length != 0) {
      this.setState({
        errors: errors,
      });
      return;
    }

    if (this.state.creating) {
      var selection = {
        ...this.state.selection,
        type: "list_field",
      };
      this.props.createCustomField(selection).then((res) => {
        var selection = res.payload;
        var helpText = selection.helpText;
        var fieldName = selection.name
        var multiSelect = selection.multiselect ? this.localizedCommons.yes : this.localizedCommons.no;
        var searchable = selection.searchable ? this.localizedCommons.yes : this.localizedCommons.no;
        var valueName = _.map(selection.options,'value');

        this.props.trackAdoptionMetricsForCustomFieldCreatedevent(fieldName,helpText,valueName,multiSelect,searchable);
        this.setState({
          creating: false,
          selection: selection,
        });
      });
    } else {
      this.props.updateCustomField(
        this.state.selection.id,
        this.state.selection,
      );
    }
  }

  _handleResetClick() {
    if (this.state.creating) {
      var selection =
        this.state.customFields && this.state.customFields.length > 0
          ? this.state.customFields[0]
          : null;
      this.setState({
        selection: selection,
        creating: false,
      });
    } else {
      selection = this.state.customFields.find((item) => {
        return item.id === this.state.selection.id;
      });
      this.setState({
        selection: selection,
      });
    }
  }

  _handleDeleteClick(field) {
    this.setState({
      deleting: true,
      deleteField: field,
    });
  }

  _onDeleteSuccess() {
    var selection =
      this.state.customFields && this.state.customFields.length > 0
        ? this.state.customFields[0]
        : null;
    this.setState({
      deleting: false,
      deleteField: null,
      selection: selection,
    });
  }

  arrangeOptions(dragIndex, hoverIndex) {
    const dragItem = this.state.customFields[dragIndex];

    if (dragItem) {
      const customFields = [...this.state.customFields];
      customFields.splice(dragIndex, 1);
      customFields.splice(hoverIndex, 0, dragItem);

      this.setState({ customFields }, () => {
        this._handleReOrderField();
      });
    }
  }

  _handleReOrderField() {
    let customFieldIds = this.state.customFields.map(
      (customField) => customField.id,
    );

    this.props.reorderCustomField(customFieldIds);
  }

  render() {
    return (
      <div>
        <Measure
          bounds
          onResize={(contentRect) => {
            var height = contentRect.bounds.height;
            this.setState({
              height: height - 150 - 47,
            });
          }}
        >
          {({ measureRef }) => (
            <div ref={measureRef} className={styles.content}>
              <h1 className={styles.heading}>
                {this.localizedCustomFields.title}
              </h1>
              <div className={styles.line}/>
              <Row className={styles.body}>
                <Col
                  md={6}
                  className={styles.menus}
                  style={{ height: this.state.height }}
                >
                  <div
                    className={cx(styles.action, styles.add)}
                    onClick={this._handleAddFieldClick}
                  >
                    <i className="paperflite-add" />{" "}
                    {this.localizedCustomFields.add_custom_fields}
                  </div>

                  <div style={{ display: "flex" }}>
                    <div style={{ width: "100%" }}>
                      {this.state.creating && this._renderUntitledFieldItem()}

                      <DNDContext
                        onDragEnd={this.handleDragEnd}
                        items={this.state.customFields.map((item) => item.id)}
                      >
                        {this._renderItems()}
                      </DNDContext>
                    </div>
                  </div>
                </Col>
                <Col
                  md={6}
                  className={styles.menuDetails}
                  style={{ height: this.state.height }}
                >
                  {this.state.selection && (
                    <DetailsView
                      item={this.state.selection}
                      onFieldChange={this._handleFieldChange}
                      creating={this.state.creating}
                      errors={this.state.errors}
                    />
                  )}
                </Col>
              </Row>
              <Row className={styles.actions}>
                <Col md={5} lg={5} xl={5} className={styles.buttonRow}>
                <Button
                  text={
                      this.props.updating || this.props.creating
                        ? `${this.localizedCommonsActions.saving_change}...`
                        : this.localizedCommonsActions.save
                    }
                    variant="primary"
                    disabled={this.props.updating || this.props.creating}
                    onClick={this._handleSaveClick}
                    icon="paperflite-tick"
                    className={styles.save}

                />
                <Button
                  text={this.localizedCommonsActions.cancel}
                  variant="secondary"
                  className={styles.reset}
                  disabled={this.props.creating || this.props.updating}
                  onClick={this._handleResetClick}
                  />

                </Col>
              </Row>
            </div>
          )}
        </Measure>
        {/* {this.state.deleting && this.state.deleteField && ( */}
          <Slider.Dialog width="23vw" show={this.state.deleting && this.state.deleteField}>
            <DeleteCustomFieldContainer
              item={this.state.deleteField}
              onDeletion={this._onDeleteSuccess}
              onCancel={() => {
                this.setState({
                  deleting: false,
                  deleteField: null,
                });
              }}
            />
          </Slider.Dialog>
        {/* )} */}
      </div>
    );
  }

  _renderUntitledFieldItem() {
    return (
      <>

      <CustomFieldItem
        item={this.state.selection}
        key="new"
        onSelection={this._handleFieldSelection}
        creating={true}
      />
      <div className={styles.line}/>
      </>
    );
  }

  handleDragEnd = (event) => {
    const { active, over } = event;

    if (!over) return;
    if (active.id === over.id) return;
    const oldIndex = this.state.customFields.findIndex(
      (item) => item.id === active.id,
    );
    const newIndex = this.state.customFields.findIndex(
      (item) => item.id === over.id,
    );
    this.setState(
      (prevState) => ({
        customFields: arrayMove(prevState.customFields, oldIndex, newIndex),
      }),
      () => {
        this._handleReOrderField();
      },
    );
  };

  _renderItems() {
    if (!this.state.customFields || this.state.customFields.length === 0) {
      return null;
    }
    return this.state.customFields.map((item, i) => (
      <DraggableFieldsView
        item={item}
        index={i}
        key={item.id}
        onDelete={this._handleDeleteClick}
        selected={this.state.selected}
        onSelection={this._handleFieldSelection}
      />
    ));
  }
}

CustomFieldView.childContextTypes = {
  selection: PropTypes.object,
};

function DNDContext(props) {
  const mouseSensor = useSensor(MouseSensor, {
    activationConstraint: {
      distance: 10,
    },
  });
  const sensors = useSensors(mouseSensor);
  return (
    <DndContext sensors={sensors} onDragEnd={props.onDragEnd}>
      <SortableContext items={props.items} strategy={rectSortingStrategy}>
        {props.children}
      </SortableContext>
    </DndContext>
  );
}

export default CustomFieldView;
